import {
    Box,
    Icon,
    Icons,
    Text,
    ThemeColorVariable,
    ThemeFontSizeVariable,
    ThemeIconSizeVariable,
    ThemeRadiusVariable,
    ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";
import { useExternalBookingSettings } from "api/api-hooks/use-external-booking-settings";
import { useBookingStateContext } from "hooks/use-booking-state";
import i18n from "i18next";
import { useTranslation } from "react-i18next";

interface ModalSelectionSearchProps {
    onClick: () => void;
}

function ModalSelectionSearch({ onClick }: ModalSelectionSearchProps) {
    const { t } = useTranslation();
    const { guests, guestsChildren, date } = useBookingStateContext();
    const { data: settings } = useExternalBookingSettings();
    const { activateWebChildren } = settings?.unitsMetaData ?? {};

    let summaryText = "";
    if (guests) {
        if (!activateWebChildren || !guestsChildren) {
            summaryText = `${guests} ${t("experienceView.guests").toLocaleLowerCase()}`;
        } else {
            summaryText = `${guests - guestsChildren} ${t("adults")}, ${guestsChildren} ${t("children")}`;
        }
    }
    const dateText = date?.locale(i18n.language).format("D MMM") ?? "";
    if (summaryText && dateText) {
        summaryText += `, ${dateText}`;
    } else if (dateText) {
        summaryText = dateText;
    }

    const placeholder = t("experienceView.selectGuestsAndDate");

    return (
        <Box
            as="button"
            type="button"
            onClick={onClick}
            aria-label={placeholder}
            display="flex"
            alignItems="center"
            flex={1}
            minW={0}
            gap={ThemeSpaceVariable.Small}
            px={ThemeSpaceVariable.Medium}
            h="40px"
            border="1px solid"
            borderColor={ThemeColorVariable.OnBackgroundBorder}
            borderRadius={ThemeRadiusVariable.XLarge}
            bg={ThemeColorVariable.Background}
            cursor="pointer"
            // @ts-expect-error _hover and _focusVisible are not typed in casper-ui-library Box
            _hover={{ borderColor: ThemeColorVariable.OnBackground }}
            _focusVisible={{ boxShadow: "var(--theme-shadows-outline)" }}
        >
            <Icon
                icon={Icons.Search}
                size={ThemeIconSizeVariable.Medium}
                color={ThemeColorVariable.OnBackground}
            />
            <Text
                flex={1}
                noOfLines={1}
                textAlign="left"
                fontSize={ThemeFontSizeVariable.Medium}
                fontWeight={summaryText ? "medium" : "normal"}
                color={
                    summaryText
                        ? ThemeColorVariable.OnBackground
                        : ThemeColorVariable.OnBackgroundSubdued
                }
            >
                {summaryText || `${placeholder} ...`}
            </Text>
        </Box>
    );
}

export { ModalSelectionSearch };
